import { CheckCircle2, ServerCrash, WifiOff } from "lucide-react";
import { useNet } from "@/lib/net";

const Bar = ({ cls, icon: Icon, text, testid }) => (
  <div role="status" className={`fixed top-0 inset-x-0 z-[100] flex items-center justify-center gap-2 py-1.5 text-[12px] font-medium text-white ${cls}`} data-testid={testid}>
    <Icon className="h-3.5 w-3.5" />{text}
  </div>
);

export default function ConnectionBanner() {
  const s = useNet();
  if (!s.online) return <Bar cls="bg-rose-600" icon={WifiOff} text="İnternet bağlantısı yok — değişiklikler kaydedilmeyebilir" testid="net-banner-offline" />;
  if (s.serverDown) return <Bar cls="bg-rose-700" icon={ServerCrash} text="Sunucuya ulaşılamıyor — değişiklikler kaydedilmeyebilir" testid="net-banner-server" />;
  if (s.recovered) return <Bar cls="bg-emerald-600" icon={CheckCircle2} text="Bağlantı geri geldi" testid="net-banner-recovered" />;
  return null;
}
